import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import getUtcStringFromOffset from 'src/imports/getUtcStringFromOffset';
import Icon from 'antd/lib/icon';
import Table from 'antd/lib/table';
import 'antd/lib/table/style/index.css';
import 'antd/lib/pagination/style/index.css';
import Tooltip from 'antd/lib/tooltip';
import 'antd/lib/tooltip/style/index.css';
import SwitchRoundFlagLocked from './SwitchRoundFlagLocked';
import SwitchRoundFlagFinalized from './SwitchRoundFlagFinalized';
import SwitchRoundFlagVisible from './SwitchRoundFlagVisible';
var tableStyles = require('src/imports/styles/extend.table.scss');
var ListRound = function (props) {
    var utcString = (React.createElement("span", { className: tableStyles.headerTextSmall },
        "(UTC ",
        getUtcStringFromOffset(props.event.utcOffset),
        ")"));
    props.rounds.sort(function (a, b) { return (a.code).localeCompare(b.code); });
    var columns = [{
            title: 'Round name',
            dataIndex: 'name',
            key: 'name',
            sorter: function (a, b) { return (a.name).localeCompare(b.name); },
            render: function (name, round) {
                var category = props.categories.find(function (c) { return c.id === round.categoryId; });
                var fullName = category ? round.code + " - " + category.name + ", " + name : name;
                return React.createElement(Link, { to: "/event/" + props.event.subdomain + "/rounds/" + round.id }, fullName);
            },
        }, {
            title: (React.createElement(Tooltip, { title: 'Locking scores for a round stop scores from being submitted by the judge app. You can still edit the scores on this platform.' },
                "Lock ",
                React.createElement(Icon, { type: 'question-circle-o', className: tableStyles.headerIcon }))),
            dataIndex: 'isScoresLockedFromUpdate',
            key: 'isScoresLockedFromUpdate',
            className: tableStyles.colCenter,
            render: function (isScoresLockedFromUpdate, round) { return (React.createElement(SwitchRoundFlagLocked, { round: round, handlePatchRound: props.handlePatchRound })); },
        }, {
            title: (React.createElement(Tooltip, { title: 'Confirming scores for a round adds a label to the scoreboard to let your athletes and spectators know that the scores have been verified by the Chief Judge' },
                "Confirm ",
                React.createElement(Icon, { type: 'question-circle-o', className: tableStyles.headerIcon }))),
            dataIndex: 'isScoresFinalized',
            key: 'isScoresFinalized',
            className: tableStyles.colCenter,
            render: function (isScoresFinalized, round) { return (React.createElement(SwitchRoundFlagFinalized, { round: round, handlePatchRound: props.handlePatchRound })); },
        }, {
            title: (React.createElement(Tooltip, { title: 'Publishing scores for a round allows athletes and spectators to see the scores and its live updates' },
                "Publish ",
                React.createElement(Icon, { type: 'question-circle-o', className: tableStyles.headerIcon }))),
            dataIndex: 'isScoresVisible',
            key: 'isScoresVisible',
            className: tableStyles.colCenter,
            render: function (isScoresHidden, round) { return (React.createElement(SwitchRoundFlagVisible, { round: round, handlePatchRound: props.handlePatchRound })); },
        }, {
            title: 'Routes',
            dataIndex: 'routeCount',
            key: 'routeCount',
            className: tableStyles.colCenter,
        }, {
            title: React.createElement("div", { className: tableStyles.headerTextMultiline },
                "Date Start",
                React.createElement("br", null),
                utcString),
            dataIndex: 'dateStart',
            key: 'dateStart',
            className: tableStyles.colCenter,
            sorter: function (a, b) {
                var timeA = moment(a.dateStart);
                var timeB = moment(b.dateStart);
                return timeA.isBefore(timeB)
                    ? -1
                    : timeA.isAfter(timeB)
                        ? 1
                        : 0;
            },
            render: function (dateStart) {
                var time = moment(dateStart).utcOffset(props.event.utcOffset);
                return (React.createElement("span", null,
                    time.format('D MMM YYYY'),
                    React.createElement("br", null),
                    time.format('h:mma')));
            },
        }, {
            title: React.createElement("div", { className: tableStyles.headerTextMultiline },
                "Date End",
                React.createElement("br", null),
                utcString),
            dataIndex: 'dateEnd',
            key: 'dateEnd',
            className: tableStyles.colCenter,
            sorter: function (a, b) {
                var timeA = moment(a.dateEnd);
                var timeB = moment(b.dateEnd);
                return timeA.isBefore(timeB)
                    ? -1
                    : timeA.isAfter(timeB)
                        ? 1
                        : 0;
            },
            render: function (dateEnd) {
                var time = moment(dateEnd).utcOffset(props.event.utcOffset);
                return (React.createElement("span", null,
                    time.format('D MMM YYYY'),
                    React.createElement("br", null),
                    time.format('h:mma')));
            },
        }];
    return (React.createElement(Table, { rowKey: 'id', columns: columns, dataSource: props.rounds, locale: { emptyText: 'No rounds in event' }, scroll: { x: 1024 }, pagination: { pageSize: 50 } }));
};
export default ListRound;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/ListRoundPage/ListRound.tsx
// module id = 1088
// module chunks = 0